import React from 'react';
import _ from 'lodash';

import { Tel } from '../Tel';
import { PostalCode } from '../PostalCode';
import ComboBox from '../../combobox/ComboBox';
import { WorkerInputText } from '../WorkerInputText.jsx';

import { PREFECTURE_GROUPS } from '../../../utilities/constants'; // 都道府県

import { CcusLineComponent, CcusTitleBlock } from '../../CcusFormComponent';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { messageUtility } from '../../../utilities/messageUtility';
import { deleteControlCode } from '../../../utilities/stringUtil';

/**
 * 作業員編集 画面 > 緊急連絡先
 */
const UrgencyContactForm = ({
  events,
  formValues,
  messages,
  disabledAll,
  comboBoxList,
  ccusDescription,
  isCcusJigyousyaDeleted,
}) => {
  if (messages.worker_urgency_contact_addresses) {
    messages = messages.worker_urgency_contact_addresses;
  }
  let hasValueCCUSbtn = false;

  const keyParams = {
    searchKey: 'relationship',
    codeKey: 'relationship_code',
    targetKey: 'relationship',
    blockKey: 'worker_urgency_contact_addresses',
  };

  const ccus_element = key => {
    const val = formValues.ccus_info ? formValues.ccus_info[key] : null;
    // BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない
    if (!isCcusJigyousyaDeleted) {
      if (!val || disabledAll) {
        return null;
      }
      hasValueCCUSbtn = true;
      return (
        <CcusLineComponent
          onClick={() => {
            events.setCCUSValues(key);
          }}
        >
          {val}
        </CcusLineComponent>
      );
    } else {
      return null;
    }
  };

  const TitleElement = ({ title, noMarginTop }) => (
    <FormListSubHeader
      title={title}
      ccusComponent={
        !disabledAll &&
        hasValueCCUSbtn && (
          <CcusTitleBlock
            onClick={e => {
              e.preventDefault();
              events.showCcusInfoTranscriptionAgreementDialog();
            }}
          />
        )
      }
      noMarginTop={noMarginTop}
    />
  );

  const workerInputTextOnChange = e => {
    events.setValueEmergency(e.target.name, e.target.value);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name, 'worker_urgency_contact_addresses');
  };

  // 都道府県リスト
  const prefectureList = [];
  _.map(PREFECTURE_GROUPS, region =>
    _.map(region.prefectures, prefecture => {
      const p = {
        id: prefecture.id,
        name: prefecture.name,
      };
      prefectureList.push(p);
    })
  );

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      {ccusDescription}
      <FormList>
        <TitleElement title='緊急連絡先' noMarginTop={true} />

        <FormListItem label='連絡先氏名' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccus_element('name')}
            validate={messages.name}
          >
            <WorkerInputText
              name='name'
              value={formValues.worker_urgency_contact_addresses.name}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='続柄' safetyDocItem={true}>
          <FormElement ccusComponent={ccus_element('relationship')}>
            <ComboBox
              listId={`${keyParams.targetKey}-list`}
              comboBoxList={comboBoxList.relationship}
              value={_.defaultTo(
                formValues.worker_urgency_contact_addresses[
                  keyParams.searchKey
                ],
                ''
              )}
              comboBoxValueKey={keyParams.searchKey}
              onChange={e =>
                events.inputValueSearch(
                  { ...formValues.worker_urgency_contact_addresses },
                  comboBoxList,
                  deleteControlCode(e.target.value),
                  -1,
                  keyParams
                )
              }
              disabled={disabledAll}
              maxLength={5}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='郵便番号'>
          <FormElement
            ccusComponent={ccus_element('postal_code')}
            validate={messages.postal_code}
          >
            {(formValues.worker_urgency_contact_addresses.postal_code ||
              !disabledAll) && (
              <PostalCode
                value={formValues.worker_urgency_contact_addresses.postal_code}
                handleOnChange={events.setValueEmergency}
                setKey='postal_code'
                tabName='worker_urgency_contact_addresses'
                readOnly={disabledAll}
                error={messages}
                validate={events.validate}
              />
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='都道府県' safetyDocItem={true}>
          <FormElement ccusComponent={ccus_element('prefectures')}>
            <ComboBox
              listId={`prefecture-list`}
              disabled={disabledAll}
              value={formValues.worker_urgency_contact_addresses.prefectures}
              comboBoxValueKey='name'
              comboBoxList={prefectureList}
              onChange={e => {
                events.setValueEmergency('prefectures', e.target.value);
              }}
              maxLength={255}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='市区町村' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccus_element('city_name')}
            validate={messages.city_name}
          >
            <WorkerInputText
              name='city_name'
              placeholder={messageUtility.getMessage('I-000-190')}
              value={formValues.worker_urgency_contact_addresses.city_name}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem
          label={messageUtility.getMessage('I-000-188')}
          safetyDocItem={true}
        >
          <FormElement
            ccusComponent={ccus_element('address1')}
            validate={messages.address1}
          >
            <WorkerInputText
              name='address1'
              placeholder={messageUtility.getMessage('I-000-191')}
              value={formValues.worker_urgency_contact_addresses.address1}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='建物名・部屋番号等' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccus_element('address2')}
            validate={messages.address2}
          >
            <WorkerInputText
              name='address2'
              placeholder='（例）赤坂ビルディング'
              value={formValues.worker_urgency_contact_addresses.address2}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='電話番号' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccus_element('tel')}
            validate={messages.tel}
          >
            {(formValues.worker_urgency_contact_addresses.tel ||
              !disabledAll) && (
              <Tel
                value={formValues.worker_urgency_contact_addresses.tel}
                handleOnChange={events.setValueEmergency}
                setKey='tel'
                tabName='worker_urgency_contact_addresses'
                readOnly={disabledAll}
                error={messages}
                validate={events.validate}
              />
            )}
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};
export default UrgencyContactForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/UrgencyContactForm.jsx